import { Route } from '@angular/router';
import { authGuard } from '@routes/guards/auth.guard';
import { guard } from '@routes/guards/guard-factory';
import { guardCreate } from '@routes/guards/guard-create';

export const regulationsRoutes: Route[] = [
    {
        path: 'regulations',
        title: 'PRSS | Положения',
        loadComponent: () =>
            import('@pages/guids/regulations/regulations-list/regulations-list.component').then(
                (c) => c.RegulationsListComponent,
            ),
        canActivate: [authGuard, guard('regulations_list')],
        data: {
            breadcrumbs: [
                { name: 'Справочники', url: '/' },
                { name: 'Положения', url: null },
            ],
            reuse: true,
            searchString: true,
        },
    },
    {
        // Маршрут :id обрабатывает и режим создания (id='create'), и просмотр существующего.
        path: 'regulations/:id',
        loadComponent: () =>
            import('@pages/guids/regulations/regulations-details/regulations-details.component').then(
                (c) => c.RegulationsDetailsComponent,
            ),
        canActivate: [authGuard, guard('regulations_list'), guardCreate('regulations_create')],
        data: {
            breadcrumbs: [
                { name: 'Справочники', url: '/' },
                { name: 'Положения', url: '/regulations' },
            ],
            searchString: false,
        },
    },
];
